import { Component, OnInit, NgZone, EventEmitter, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import * as Materialize from 'angular2-materialize/dist/index';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { materialAdminService } from './materialadmin.service';
import { NavbarService } from '../navbar/navbar.service';

@Component({
  selector: 'app-materialadmin',
  templateUrl: './materialadmin.component.html',
  styleUrls: ['./materialadmin.component.css'],
  providers: [materialAdminService]
})
export class MaterialadminComponent implements OnInit, OnDestroy {

  planid: string;
  noMaterial: boolean;
  loadingMaterials: boolean;
  waiticon: string;
  selectedCategoryValueName: string;

  materials = [];
  materialcategories = [];
  units = [];
  materialEdit: any = {};
  mcategoryIndexToIDDict: any = {};
  selectcategoryIndex: number;
  Categoryselect: number;
  Unitselect: number;

  selectedCategoryValue: any = {};
  selectedmaterial: any = {};
  canRemoveCategory: boolean;
  selectedMaterials = [];
  newCategoryForMaterialChange: number;
  public currencySymbol: string;
  public currencyName: string;

  modalNewCategoryAction = new EventEmitter<string | MaterializeAction>();
  modalNewMaterialAction = new EventEmitter<string | MaterializeAction>();
  modalEditMaterialAction = new EventEmitter<string | MaterializeAction>();
  modalEditCategoryAction = new EventEmitter<string | MaterializeAction>();
  modalConfirmRemoveMaterialAction = new EventEmitter<string | MaterializeAction>();
  modalConfirmRemoveCategoryAction = new EventEmitter<string | MaterializeAction>();

  constructor(private router: Router,
              public materialAdminService: materialAdminService,
              private ngZone: NgZone,
              public navService: NavbarService) { }

  ngOnInit() {
    this.navService.show('MATERIAL ADMIN');
    this.navService.setNavID(5);
    this.planid = localStorage.getItem('mr_planid');
    this.noMaterial = true;
    this.loadingMaterials = true;
    this.currencySymbol = localStorage.getItem('mr_currency_symbol');
    this.currencyName = localStorage.getItem('mr_currency_id');
    let admin = localStorage.getItem('isAdmin');

    this.refreshMaterials();
  }

  ngOnDestroy() {
    this.modalNewCategoryAction.emit({ action: 'modal', params: ['close'] });
    this.modalNewMaterialAction.emit({ action: 'modal', params: ['close'] });
    this.modalEditMaterialAction.emit({ action: 'modal', params: ['close'] });
    this.modalEditCategoryAction.emit({ action: 'modal', params: ['close'] });
    this.modalConfirmRemoveMaterialAction.emit({ action: 'modal', params: ['close'] });
    this.modalConfirmRemoveCategoryAction.emit({ action: 'modal', params: ['close'] });
  }

    onNewCategoryForMaterialChange(value) {
    this.newCategoryForMaterialChange = value;
  }

  refreshMaterials() {

    this.materials = [];
    this.materialcategories = [];
    this.units = [];


    this.loadingMaterials = true;
    this.materialAdminService.getMaterials()
      .subscribe(
      data => {

        console.log('Got material');
        let jsondata = JSON.parse(data);
            this.loadingMaterials = false;

        this.materials = jsondata.materials;
        this.materialcategories = jsondata.materialcategories;
        if (this.materialcategories.length <= 0)
               this.noMaterial = true;
        else
               this.noMaterial = false;

        for (let i = 0; i < this.materialcategories.length; i++) {
          this.mcategoryIndexToIDDict[this.materialcategories[i].id] = i + 1;
        }

        this.units = jsondata.materialunits;

        let category = JSON.stringify({
          id: 0, name: 'Choose Category', enabled: 3
        });
        let categoryJson = JSON.parse(category);

        let unit = JSON.stringify({
          id: 0, name: 'Choose Unit', enabled: 3
        });
        let unitJson = JSON.parse(unit);

        this.materialcategories.splice(0, 0, categoryJson);
        this.units.splice(0, 0, unitJson);
        if (this.selectcategoryIndex)
          this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
            document.getElementById('category' + this.selectcategoryIndex).click();
          });
      },
      error => {
        this.loadingMaterials = false;
        this.noMaterial = true;
        //this.loadingcustomers = false;
      });
  }
  openNewCategoryModal() {

    (<HTMLInputElement>document.getElementById('material_category_name')).value = '';
    this.modalNewCategoryAction.emit({ action: 'modal', params: ['open'] });
  }

  openNewMaterialModal() {

    (<HTMLInputElement>document.getElementById('materialSelectedCategoryId')).value = '0';
    (<HTMLInputElement>document.getElementById('materialunitSelected')).value = '0';
    (<HTMLInputElement>document.getElementById('AlloyNameInput')).value = null;
    (<HTMLInputElement>document.getElementById('AlloyDescInput')).value = null;
    (<HTMLInputElement>document.getElementById('densityEnglishInput')).value = null;

    this.modalNewMaterialAction.emit({ action: 'modal', params: ['open'] });
  }

  createNewMaterial(){

   let materialSelectedCategoryId =   (<HTMLInputElement>document.getElementById('materialSelectedCategoryId')).value;
   let materialunitSelected =   (<HTMLInputElement>document.getElementById('materialunitSelected')).value;
   let AlloyNameInput =   (<HTMLInputElement>document.getElementById('AlloyNameInput')).value;
   let AlloyDescInput =   (<HTMLInputElement>document.getElementById('AlloyDescInput')).value;
   let densityEnglishInput =   (<HTMLInputElement>document.getElementById('densityEnglishInput')).value;
   let AlloyPrice = (<HTMLInputElement>document.getElementById('defaultPriceInput')).value;

   this.selectcategoryIndex = this.mcategoryIndexToIDDict[parseInt(materialSelectedCategoryId)];
   if (AlloyNameInput.length <= 0 || materialSelectedCategoryId == '0')
   {
     Materialize.toast('MATERIAL AND CATEGORY ARE REQUIRED FIELDS.', 1500);
     console.log('MATERIAL AND CATEGORY ARE REQUIRED FIELDS.');
     return;
   }

   this.waiticon = 'fa right fa-spinner fa-pulse';

   this.materialAdminService.addNewMaterial(AlloyNameInput, parseInt(materialSelectedCategoryId), AlloyDescInput, parseInt(materialunitSelected), densityEnglishInput, AlloyPrice).subscribe(
      data => {
        try {
          let json = JSON.parse(data);
          if (json == true) {
            this.waiticon = '';
            this.refreshMaterials();
            Materialize.toast('MATERIAL ' + AlloyNameInput + ' CREATED SUCCESSFULLY.', 1500);
            console.log('MATERIAL CONSUMABLES CREATED SUCCESSFULLY.');
            this.modalNewMaterialAction.emit({ action: 'modal', params: ['close'] });
          }
          else {
            Materialize.toast('MATERIAL IS ALREADY PRESENT. PLEASE TRY AGAIN WITH ANOTHER MATERIAL NAME.', 1500);
            console.log('MATERIAL IS ALREADY PRESENT. PLEASE TRY AGAIN WITH ANOTHER MATERIAL NAME.');
            this.waiticon = '';
          }
        }
        catch (e) {
          console.log('MATERIAL IS ALREADY PRESENT, PLEASE TRY WITH ANOTHER MATERIAL NAME.  ' + data);
          Materialize.toast('MATERIAL IS ALREADY PRESENT, PLEASE TRY WITH ANOTHER MATERIAL NAME.', 1500);
          this.waiticon = '';
        }
      },
      error => {
        console.log('INTERNAL  ERROR WHILE ADDING MATERIAL : ' + error);
        Materialize.toast('INTERNAL  ERROR WHILE ADDING MATERIAL.', 1500);
        this.waiticon = '';
      });

  }


  openEditMaterialModal(material: any) {

    this.selectedmaterial = material;
    (<HTMLInputElement>document.getElementById('category_idEdit')).value = this.selectedmaterial.materialcategory_id;
    (<HTMLInputElement>document.getElementById('unitEditSelect')).value = this.selectedmaterial.materialunit_id;

    this.modalEditMaterialAction.emit({ action: 'modal', params: ['open'] });
  }

  openEditCategoryModal(materialcategory: any) {

    document.getElementById('categoryNameEditValue').style.display = 'block';
    document.getElementById('categoryNameEditInput').style.display = 'none';
    document.getElementById('categoryNamePencil').style.display = 'block';
    document.getElementById('categoryNameApply').style.display = 'none';
    document.getElementById('categoryNameCancel').style.display = 'none';
    this.selectedCategoryValueName = materialcategory.name;
    this.selectedCategoryValue = materialcategory;
    this.modalEditCategoryAction.emit({ action: 'modal', params: ['open'] });

  }



  openConfirmRemoveMaterialModal(material: any) {

    this.selectedmaterial = material;
    this.modalConfirmRemoveMaterialAction.emit({ action: 'modal', params: ['open'] });
  }

  openConfirmRemoveCategoryModal(materialcategory: any) {

    this.selectedCategoryValue = materialcategory;
    this.selectedCategoryValueName = materialcategory.name;
    this.selectedCategoryValue = materialcategory;
    this.canRemoveCategory = true;
     this.selectedMaterials = [];

    for (let i = 0; i < this.materials.length; i++) {
      if (materialcategory.id == this.materials[i].materialcategory_id) {
        this.canRemoveCategory = false;
        this.selectedMaterials.push(this.materials[i].id);
      }
    }

    if ( this.canRemoveCategory)
    (<HTMLInputElement>document.getElementById('selectMaterialCategory')).value = '0';

    this.modalConfirmRemoveCategoryAction.emit({ action: 'modal', params: ['open'] });
  }


  /**
* Called from collapsible material Header to make changes in UI and
*
* @param
*
* @return   void
*/
  materialCategoryHeaderClicked(index: number) {
    console.log('materialHeaderClicked');
    console.log(' Index : ', index);

    if (document.getElementById(index + '_collapsible_body').className != 'active') {

      document.getElementById('categoryarrowexpand' + index).style.display = 'block';
      document.getElementById('categoryarrowright' + index).style.display = 'none';

      document.getElementById('categoryRemove' + index).className = 'visibility-Vis';
      document.getElementById('categoryEdit' + index).className = 'visibility-Vis';
    }
    else {
      document.getElementById('categoryarrowexpand' + index).style.display = 'none';
      document.getElementById('categoryarrowright' + index).style.display = 'block';

      document.getElementById('categoryEdit' + index).className = 'visibility-Hid';
      document.getElementById('categoryRemove' + index).className = 'visibility-Hid';
    }

    let numberofRows = document.getElementById('materialtabel' + index).getElementsByTagName('tbody')[0].getElementsByTagName('tr').length;

    if (numberofRows <= 0) {
      document.getElementById('filledcategory' + index).style.display = 'none';
    }
    else {
      document.getElementById('emptycategory' + index).style.display = 'none';
    }
  }

  /**
  * Create New Category in MR2 Database
  * Calls addCategory service with category_name to create new materialcategory in datbase.
  *
  * @return void
  */
  createNewCategory() {

    this.waiticon = 'fa right fa-spinner fa-pulse';
    let category_name = (<HTMLInputElement>document.getElementById('material_category_name')).value;


    if (!category_name) {
      Materialize.toast('PLEASE ADD CATEGORY NAME.', 1500);
      console.log('PLEASE ADD CATEGORY NAME.');
      this.waiticon = '';
      return;
    }

     Materialize.toast('CREATING CATEGORY...', 1500);

     category_name = category_name.toUpperCase();
     this.materialAdminService.addNewCategory(category_name).subscribe(
      data => {
        try {
          let json = JSON.parse(data);
          if (json == true) {
            this.waiticon = '';
            this.refreshMaterials();
            Materialize.toast('CATEGORY ' + category_name + ' CREATED SUCCESSFULLY.', 1500);
            console.log('CATEGORY CONSUMABLES CREATED SUCCESSFULLY.');
            this.modalNewCategoryAction.emit({ action: 'modal', params: ['close'] });
          }
          else {
            Materialize.toast('CATEGORY IS ALREADY PRESENT. PLEASE TRY AGAIN WITH ANOTHER CATEGORY NAME.', 1500);
            console.log('CATEGORY IS ALREADY PRESENT. PLEASE TRY AGAIN WITH ANOTHER CATEGORY NAME.');
            this.waiticon = '';
          }
        }
        catch (e) {
          console.log('CATEGORY IS ALREADY PRESENT, PLEASE TRY WITH ANOTHER CATEGORY NAME.  ' + data);
          Materialize.toast('CATEGORY IS ALREADY PRESENT, PLEASE TRY WITH ANOTHER CATEGORY NAME.', 1500);
          this.waiticon = '';
        }
      },
      error => {
        console.log('INTERNAL ERROR WHILE ADDING CATEGORY NAME : ' + error);
        Materialize.toast('INTERNAL  ERROR WHILE ADDING CATEGORY NAME.', 1500);
        this.waiticon = '';
      });
  }

  /**
  * Remove Category from MR2 Database
  * Calls RemoveCategory service with category_name to remove aterialcategory from datbase.
  *
  * @return void
  */

  RemoveCategoryConfirm() {

    Materialize.toast('REMOVING CATEGORY ...', 1000);
    this.waiticon = 'fa right fa-spinner fa-pulse';

    this.materialAdminService.removeCategory(this.selectedCategoryValue)
      .subscribe(
      data => {
        // Need to add return check
        Materialize.toast('MATERIAL ' + this.selectedCategoryValue.name + ' REMOVED.', 1500);
        this.refreshMaterials();
        this.modalConfirmRemoveCategoryAction.emit({ action: 'modal', params: ['close'] });
        this.waiticon = '';
      },
      error => {
        Materialize.toast('INTERNAL ERROR.', 1500);
        console.log('INTERNAL ERROR.');
        this.waiticon = '';
      });
  }

  /**
  * Remove Material from MR2 Database
  * Calls RemoveMaterial service with category_name to remove aterialcategory from datbase.
  *
  * @return void
  */

  RemoveMaterialConfirm() {
    this.waiticon = 'fa right fa-spinner fa-pulse';
    Materialize.toast('REMOVING MATERIAL ...', 1000);
    this.materialAdminService.removeMaterial(this.selectedmaterial)
      .subscribe(
      data => {
        // Need to add return check
        Materialize.toast('MATERIAL ' + this.selectedCategoryValue.name + ' REMOVED.', 1500);
        this.refreshMaterials();
        this.modalConfirmRemoveMaterialAction.emit({ action: 'modal', params: ['close'] });
        this.waiticon = '';
      },
      error => {
        Materialize.toast('INTERNAL ERROR.', 1500);
        console.log('INTERNAL ERROR.');
        this.waiticon = '';
      });

  }

  RemoveMaterialCancel() {
  }


  /**
 * inables submit and cancal
 * stores selectedCategoryName.
 *
 * @return void
 *
 */
  categoryEditClicked() {

    document.getElementById('categoryNameEditValue').style.display = 'none';
    document.getElementById('categoryNameEditInput').style.display = 'block';

    document.getElementById('categoryNamePencil').style.display = 'none';
    document.getElementById('categoryNameApply').style.display = 'block';
    document.getElementById('categoryNameCancel').style.display = 'block';
  }

  categoryEditSaveClicked() {

    let categorname = (<HTMLInputElement>document.getElementById('categoryNameEditInputValue')).value;

    if (categorname.length <= 0) {
      Materialize.toast('PLEASE ADD CATEGORY NAME.', 1500);
      return;
    }

    this.selectedCategoryValueName = categorname;
    document.getElementById('categoryNameEditValue').style.display = 'block';
    document.getElementById('categoryNameEditInput').style.display = 'none';
    document.getElementById('categoryNamePencil').style.display = 'block';
    document.getElementById('categoryNameApply').style.display = 'none';
    document.getElementById('categoryNameCancel').style.display = 'none';

    this.editCategorySubmit();
  }



  categoryEditCancelClicked() {

    this.selectedCategoryValue.name = this.selectedCategoryValueName;

    document.getElementById('categoryNameEditValue').style.display = 'block';
    document.getElementById('categoryNameEditInput').style.display = 'none';
    document.getElementById('categoryNamePencil').style.display = 'block';
    document.getElementById('categoryNameApply').style.display = 'none';
    document.getElementById('categoryNameCancel').style.display = 'none';
  }


  /**
* Edit Category in MR2 Database
* Calls EditCategory service with category_name to create edit materialcategory in datbase.
*
* @return void
*/

  editCategorySubmit() {
    this.waiticon = 'fa right fa-spinner fa-pulse';
        Materialize.toast('UPDATING CATEGORY ...', 1000);
    this.materialAdminService.editCategory(this.selectedCategoryValue, this.selectedCategoryValueName.toUpperCase())
      .subscribe(
      data => {

        try {
          let json = JSON.parse(data);
          if (json == true) {

            this.selectedCategoryValue.name = this.selectedCategoryValueName.toUpperCase();
            Materialize.toast('CATEGORY NAME UPDATED SUCCESSFULLY.', 1500);
            console.log('CATEGORY NAME UPDATED SUCCESSFULLY.');

            this.modalEditCategoryAction.emit({ action: 'modal', params: ['close'] });
            this.waiticon = '';
          }
          else {
            Materialize.toast('CATEGORY NAME IS ALREADY PRESENT, PLEASE TRY WITH ANOTHER NAME.', 1500);
            console.log('CATEGORY IS ALREADY PRESENT, PLEASE TRY WITH ANOTHER  NAME.');
            this.waiticon = '';
          }
        }
        catch (e) {
          console.log('ERROR UPDATING MATERIAL.' + e);
          Materialize.toast('ERROR UPDATING MATERIAL.', 1500);
          this.waiticon = '';
        }
      },
      error => {
        console.log('INTERNAL ERROR.');
        Materialize.toast('INTERNAL ERROR.', 1500);
        this.waiticon = '';
      });
  }

  onCategoryChange(value) {
    console.log('Category value', value);
    this.Categoryselect = value;
  }

  onUnitChange(value) {
    console.log('Unit value', value);
    this.Unitselect = value;
  }

   editRow(control) {
    // console.log('control : ', control, ' project : ', this.resourcesEdit);
    document.getElementById(control).style.display = 'none';
    document.getElementById(control + 'Edit').style.display = 'block';

    document.getElementById(control + 'Pencil').style.display = 'none';
    document.getElementById(control + 'Apply').style.display = 'block';
    document.getElementById(control + 'Cancel').style.display = 'block';

    // this.Categoryselect = this.resourcesEdit.category_id;
    // this.Locationselect = this.resourcesEdit.location_id;
  }


  cancelEditRow(control) {
    document.getElementById(control).style.display = 'block';
    document.getElementById(control + 'Edit').style.display = 'none';
    // (<HTMLInputElement>document.getElementById(control + 'Edit')).value = this.resourcesEdit[control];

    document.getElementById(control + 'Pencil').style.display = 'block';
    document.getElementById(control + 'Apply').style.display = 'none';
    document.getElementById(control + 'Cancel').style.display = 'none';
  }
  saveRow(control) {
  }

  updateMaterialCategory(){
         this.waiticon = 'fa right fa-spinner fa-pulse';
         let resourceSelectedCategoryId;
        if (!this.newCategoryForMaterialChange)
          resourceSelectedCategoryId = (<HTMLInputElement>document.getElementById('selectMaterialCategory')).value;
        else
          resourceSelectedCategoryId = this.newCategoryForMaterialChange;
        //  this.selectedResources
        let oldCategory = this.selectedCategoryValue.id;

        //  for(var i = 0; i < this.selectedResources.length; i++ )
        //  {
            this.waiticon = 'fa right fa-spinner fa-pulse';
        this.materialAdminService.updateResourcescategories( oldCategory, parseInt(resourceSelectedCategoryId))
       .subscribe(
       data => {
        // Need to add return check
        //  Materialize.toast("UpdateResourcesCategory " +i +" of "+ this.selectedResources.length , 1500);

         this.waiticon = '';
         this.refreshMaterials();
         this.canRemoveCategory = true;
        //  this.refreshResources();
       },
       error => {
        Materialize.toast('INTERNAL ERROR.', 1500);
        console.log('INTERNAL ERROR.');
        this.waiticon = '';
      });

  //  }
}

  updateMaterial() {

    this.waiticon = 'fa right fa-spinner fa-pulse';
    Materialize.toast('MATERIAL PROPERTY UPDATING...', 1000);

    let updateResource = {
      id: this.selectedmaterial.id,
      name: (<HTMLInputElement>document.getElementById('nameEdit')).value,
      materialcategory_id: (<HTMLInputElement>document.getElementById('category_idEdit')).value,
      description: (<HTMLInputElement>document.getElementById('descriptionEdit')).value,
      density: (<HTMLInputElement>document.getElementById('densityEdit')).value,
      materialunit_id: (<HTMLInputElement>document.getElementById('unitEditSelect')).value,
      price: (<HTMLInputElement>document.getElementById('priceEdit')).value
    };

    this.materialAdminService.updateMaterial(updateResource)
      .subscribe(
      data => {
         this.waiticon = '';
        console.log('Material updated to DB');
        Materialize.toast('MATERIAL UPDATED SUCCESSFULLY.', 1000);
        this.modalEditMaterialAction.emit({ action: 'modal', params: ['close'] });
        this.refreshMaterials();
        // let projectdata = JSON.parse(data);
        // Materialize.toast('Project property updated.', 1000);
        // this._projectDataService.setForceUpdateBool(true);
      },
      error => {
        console.log('Error updating material');
        Materialize.toast('ERROR UPDATING MATERIAL.', 1000);
           this.waiticon = '';
        // let projectdata = JSON.parse(data);
        // Materialize.toast('Project property updated.', 1000);
        // this._projectDataService.setForceUpdateBool(true);
      });
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/materialadmin/materialadmin.component.ts